import DisplayDataServer from "../../components/admin/DisplayDataServer";
const Partnership=()=>{
   return <DisplayDataServer name={"Partenaires"} type={"partnership"}/>;
}

export default Partnership;